export function formattedPhone(phone: string) {
  const nonNumericCharacters = /[^0-9]/g
  const phoneFormat = /^(\d\d)(\d{4,5})(\d{4}).*/

  return phone.startsWith('08')
        ? phone
        : phone?.replace(nonNumericCharacters, '').replace(phoneFormat, '($1) $2-$3')
}